export default "__VITE_ASSET__DTS9rbW$__"